module.exports = __webpack_public_path__ + "img/arrow_up_square.90243629.svg";